import { call, put, select } from 'redux-saga/effects'
import { updateContractConfigData, updateContractConsumptionData } from '../../SubscriptionForm/SubscriptionFormSlice'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { amountParametersGeneration } from './Fields/AmountField/amountParametersGeneration'
import { selectAuthData, selectEnergyAuthCommonData } from '../../../Login/AuthSelectors'
import {
  selectAddressCurrentContractActive,
  selectCharacteristicsCurrentContractActive,
  selectConfig,
  selectConsumptionCurrentContractActive,
  selectContractDetailsCurrentContractActive,
  selectElecCurrentContractActive,
  selectOfferConfigCurrentContractActive,
  selectPreferencesClientSubscriptionData,
  selectProviderConfigCurrentContractActive,
} from '../../SubscriptionForm/SubscriptionFormSelectors'
import * as Sentry from '@sentry/react'

export const consumptionModuleActions = {
  CONSUMPTION_MODULE_CALCULATE_PRICE_V2: 'CONSUMPTION_MODULE_CALCULATE_PRICE_V2',
}

export function* calculateOfferPrice({ id }) {
  const { calculateMonthlyAmountUrl } = yield select(selectEnergyAuthCommonData)
  const { providerWorkflow } = yield select(selectProviderConfigCurrentContractActive)
  const { country } = yield select(selectAuthData)
  const { contactId } = yield select(selectConfig)
  const activeAddress = yield select(selectAddressCurrentContractActive)
  const activeCharacteristics = yield select(selectCharacteristicsCurrentContractActive)
  const activeContractDetails = yield select(selectContractDetailsCurrentContractActive)
  const clientPreferences = yield select(selectPreferencesClientSubscriptionData)
  const consumptionData = yield select(selectConsumptionCurrentContractActive)
  const offerConfig = yield select(selectOfferConfigCurrentContractActive)
  const activeElecData = yield select(selectElecCurrentContractActive)

  const params = amountParametersGeneration({
    workflowName: providerWorkflow,
    contractId: id,
    country,
    contactId,
    activeAddress,
    activeCharacteristics,
    activeContractDetails,
    clientPreferences,
    consumptionData,
    offerConfig,
    activeElecData,
  })

  yield put(
    updateContractConsumptionData({
      id,
      data: {
        amounts: { total: [], elec: [], gas: [] },
        monthlyAmount: null,
        monthlyAmountElec: null,
        monthlyAmountGas: null,
      },
    }),
  )

  yield put(
    updateContractConfigData({
      id,
      data: {
        offerPriceLoading: true,
        offerPriceError: null,
      },
    }),
  )

  try {
    yield call(callApi, {
      endpoint: calculateMonthlyAmountUrl,
      showErrorSnackbar: false,
      method: 'POST',
      payload: params,
    })
  } catch (error) {
    yield put(
      updateContractConfigData({
        id,
        data: {
          offerPriceLoading: false,
          offerPriceError: error.responseData?.message || 'An error occurred while calculating the offer price.',
        },
      }),
    )
    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(new Error('calculateOfferPriceError'), { extra: { error } })
    }
  }
}
